<template>
  <v-container class="topo px-0" fluid>
  <!-- ------------ FUNDO ------------ -->
    <v-row class="bg"></v-row>
    <!-- V 2.0.1 -->
  <!-- -------------- PARTE DE CIMA ----------------- -->
    <v-container
      class="first-row"
      fluid
    >
      <!-- JUNTE-SE AO DEBATE -->
      <v-row
        class="d-flex py-2"
        justify="center"
      >
        <v-col cols="11" md="10" class="pa-0">
            <!-- FB GROUP -->
            <v-card
              class="mt-0 px-4 py-2 rounded-xl get-online align-center d-flex justify-center"
              style="border-radius: 100px"
              flat
              color=""
              href=""
            >
              <p  class="overline mb-0 pl-1 py-0">
                Junte-se aos grupos de debate nas mídias sociais:
              </p>
              <v-spacer></v-spacer>
              <a
                href="https://www.facebook.com/groups/508854890153685"
                target="_blank"
                class="ma-1 mr-4"
                style="text-decoration: none"
              >
                <v-icon color="blue darken-2" large>facebook</v-icon>
              </a>
              <a
                href="https://www.linkedin.com/groups/9060410/"
                target="_blank"
                class="ma-1 mr-4"
                style="text-decoration: none"
              >
                <v-icon color="blue lighten-2" large>mdi-linkedin</v-icon>
              </a>
            </v-card>
        </v-col>
      </v-row>
      <!-- VIDEO E COMENTARIOS -->
      <v-row
        align="stretch"
        class="d-flex pb-8"
        justify="center"
      >
        <v-col cols="11" md="10" class="px-0">
          <v-card class="round-corner py-2 px-5">
            <v-row class="d-flex justify-center">

              <!-- COL VIDEO -->
              <v-col cols="12" md="8" lg="8" class="pa-0">
                <!-- ---------- VIDEO ------------- -->
                  <v-sheet v-if="video.url" class="video round-corner" width="100%">
                    <v-responsive :aspect-ratio="16/9">
                      <iframe
                        :src="video.url"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        class="round-corner"
                      ></iframe>
                    </v-responsive>
                  </v-sheet>
                  <v-sheet v-else class="video round-corner" width="100%">
                    <v-responsive :aspect-ratio="16/9">
                      <v-img
                        alt="Logo do 1º Curso de Cannabis Medicinal para Reumatologista"
                        class="logo-top shrink mr-2"
                        contain
                        src="@/assets/thumb.png"
                        transition="scale-transition"
                        max-height="100%"
                        position="center center"
                      ></v-img>
                    </v-responsive>
                  </v-sheet>
                  <!-- ---------- INPUT COMENTARIO ----------- -->
                  <div class="comment-input pa-0 my-4" v-if="video.display">
                    <v-text-field
                      v-model="comentario"
                      label="Deixe seu comentário..."
                      color="teal"
                      filled
                      outlined
                      rounded
                      dense
                      append-outer-icon="mdi-send ml-2 pa-2 full-round-corner white--text"
                      @click:append-outer="sendMessage"
                      hide-details
                      class="mr-4 com-input"
                    ></v-text-field>
                  </div>
              </v-col>

              <v-spacer></v-spacer>

              <!-- ------------ COL COMENTÁRIOS ------------ -->
              <v-col
                v-if="video.display"
                cols="12"
                md="4"
                lg="4"
                class="comment-col"
                style="position: relative; overflow: hidden"
              >
                <!-- GO LIVE -->
                <GoLive v-if="getGoLiveEnabled" />
                <p class="overline ml-2 mt-0 mb-3 text-center"><span class="btn-primary px-1">Comentários</span></p>
                <!-- LISTA COMENTÁRIOS -->
                <v-card
                  class="mt-0 px-2 px-md-6 round-corner comment-container"
                  flat
                  color="grey lighten-5"
                  width="100%"
                >
                  <!-- ------- NINGUEM COMENTOU ------- -->
                  <!-- <v-row v-if="comentarios.length < 1" class="text-center px-6 com"> -->
                  <v-row v-if="comentarios.length < 1" class="text-center px-6 com" style="height: 100%;">
                    <v-col cols="12" class="my-auto">
                      <v-img
                        src="@/assets/comments.svg"
                        position="center"
                        width="100%"
                        contain
                        max-height="40px"
                      ></v-img>
                      <!-- <i class="fas fa-comments"></i> -->
                      <p class="mt-4 grey--text caption mx-8">Não comentaram neste vídeo até o momento</p>
                    </v-col>
                  </v-row>
                  <!-- ----------- COMENTARAM ----------- -->
                  <v-card
                    v-else
                    id="comment-list"
                    flat
                  >
                    <!-- REAL -->
                    <div
                      v-for="(comentario, i) in comentarios"
                      :key="i"
                      class="my-2 px-2 py-2 round-corner"
                    >
                      <p class="font-weight-bold black--text">{{ comentario.from }} <span>{{ comentario.timestamp }}</span></p>
                      <p class="pl-1 mt-1 black--text">{{ comentario.msg }}</p>
                    </div>
                    <!-- TESTE -->
                    <!-- <div
                      v-for="(comentario, i) in 15"
                      :key="i"
                      class="my-2 px-2 py-2 round-corner"
                    >
                      <p class="font-weight-bold black--text">comentario.from<span>comentario.timestamp</span></p>
                      <p class="pl-1 mt-1 black--text">comentario.msg</p>
                    </div> -->
                  </v-card>
                  <v-sheet v-if="comentarios.length != 0" class="gradient-overlay"></v-sheet>
                </v-card>
              </v-col>
            </v-row>
          </v-card>

        </v-col>
      </v-row>
      <!-- PROGRAMA -->
      <v-row justify="center">
        <v-col cols="12" md="10">
          <h3 class="text-center txt2 mb-8"><span class="btn-primary px-1">Programa do Curso</span></h3>
          <v-expansion-panels class="programa">
            <v-expansion-panel
              v-for="(item,i) in programa"
              :key="i"
            >
              <v-expansion-panel-header class="txt-2 text-center">
                <p class=" mb-0 caption"><b>{{ item.title.pre }}</b> - {{ item.title.txt }}</p>
                <template v-slot:actions>
                  <v-icon class="cc-primary--text">
                    $expand
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-4">
                <!-- <ul>
                  <li v-for="(palestra, i) in item.palestras" :key="i" class="palestra">
                    <v-icon color="green">mdi-square-small</v-icon>
                    {{ palestra.nome }}
                  </li>
                </ul> -->
                <div v-for="(palestra, i) in item.palestras" :key="i" class="palestra text-center">
                  <p class="hora">{{ palestra.hora }}</p>
                  <p class="nome body-2">{{ palestra.nome }}</p>
                  <p class="palestrante">{{ palestra.palestrante }}</p>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <!-- -------------- PUBLICIDADE -------------- -->
      <!-- <v-row justify="center" class="mt-12">
        <v-col
          cols="12"
          :md="video.display ? '10' : '9'"
          class="px-2"
        >
          <MainSlider />
        </v-col>
      </v-row> -->

      <!-- PATROCINIO -->
      <!-- <v-row id="patrocinio">
        <div class="gradient2"></div>
        <div class="container">
          <h2>Patrocínio</h2>
          <div class="sponsors">
            <div class="img"><img src="@/assets/greencare.png" alt=""></div>
          </div>
        </div>
      </v-row> -->

    </v-container>

    <CompForm />

    <!-- LGPD -->
    <!-- <LGPD /> -->
  </v-container>
</template>

<script>
// import HelloWorld from '../components/HelloWorld'
import db from '@/firebase/init'
import firebase from 'firebase'
import moment from 'moment'
import CompForm from '@/components/auth/CompForm'
import LGPD from '@/components/LGPD/LGPD'
import MainSlider from '@/components/sliders/mainSlider.vue'
import GoLive from '@/components/layout/GoLive'
import {mapGetters, mapActions} from "vuex"
// import ShareBtn from '@/components/ShareBtn.vue'

export default {
  name: 'Index',
  components: {
    MainSlider,
    LGPD,
    // ShareBtn,
    CompForm,
    GoLive,
  },
  data(){
    return{
      videoId: 'cc2',
      golive: false,
      user: null,
      comentario: null,
      comentarios: [],
      video: {},
      show: false,
      sponsors: [],
      patrocinio: [],
      videos: [],
      hoje: Date.now(),
      testcomments: [
        {
          from: "angelaguerrarj@gmail.com",
          msg: "Muito boa a aula. Parabéns Cinthia, obrigada Selma pelas apresentações.",
          timestamp: 1602634938843,
        }
      ],
      programa: [
        {
          title: {
            pre: 'Bloco 1',
            txt: 'O Canabidiol e Seus Derivados',
          },
          palestras: [
            {
              hora: '08h - 8:10h',
              nome: 'Abertura e apresentação dos palestrantes',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '08:10h - 8:30h',
              nome: 'História da Cannabis medicinal',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '8:30h - 09h',
              nome: 'Legislação e normas da Cannabis medicinal no Brasil',
              palestrante: 'Dra. Alessandra Soares'
            },
            {
              hora: '09h - 09:30h',
              nome: 'Sistema endocanabinoide',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '09:30h - 09:50h',
              nome: 'Fitocanabinoides: CBD, THC, Terpenos e Flavonoides',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '09:50h - 10h',
              nome: 'Perguntas e respostas',
              palestrante: ''
            },
            {
              hora: 'Intervalo de 15 minutos',
              nome: '',
              palestrante: ''
            },
          ]
        },
        {
          title: {
            pre: 'Bloco 2',
            txt: 'Indicações do Canabidiol',
          },
          palestras: [
            {
              hora: '10:15h – 10:45h',
              nome: 'Aplicações Clínicas: Geriatria e Medicina paliativa',
              palestrante: 'Dr. Filipe Gusman'
            },
            {
              hora: '10:45h – 11:00h',
              nome: 'Aplicações Clínicas: Medicina do Esporte – Doping no Esporte',
              palestrante: 'Dr José Kawazoe'
            },
            {
              hora: '11:00h – 11:30h',
              nome: 'Aplicações Clínicas: Medicina do Esporte',
              palestrante: 'Dra Natalia Mourão/ Dr. Jimmy Fardin'
            },
            {
              hora: '11:30h – 12:00h',
              nome: 'Aplicações Clínicas: Lesões de atletas',
              palestrante: 'Diogo Souza'
            },
            {
              hora: 'Intervalo de 20 minutos',
              nome: '',
              palestrante: ''
            },
          ]
        },
        {
          title: {
            pre: 'Bloco 3',
            txt: 'Prescrições e casos clínicos do Canabidiol e seus derivados',
          },
          palestras: [
            {
              hora: '12:20h – 12:50h',
              nome: 'Aplicações Clínicas : Psiquiatria',
              palestrante: 'Dr. Octavio Pavan'
            },
            {
              hora: '12:50h – 13:20h',
              nome: 'Aplicações Clínicas : Reumatologia',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '13:20h – 14:00h',
              nome: 'Casos Clínicos, regras para prescrição e Fechamento',
              palestrante: 'Dra. Selma Merenlender'
            },
          ]
        },

      ],
    }
  },
  computed: {
    ...mapGetters(['getGoLiveEnabled']),
  },
  beforeMount() {
    this.getVideo(this.videoId)
    // this.getVideoAction()
    if(!this.$store.getters.getUser.cc2){
      this.$router.push('/')
    } else {
      console.log('ta liberado')
    }
  },
  mounted() {
    this.$vuetify.theme.dark = false
    moment.locale('pt-br')
    // console.log(moment(Date.now()).format('dddd'))
    firebase.auth().onAuthStateChanged(user => {
      this.user = user
    })
    // console.log(this.user)
    // this.getVideo()
  },
  updated() {
    this.comentarios.forEach(comentario => {
      let ts = comentario.timestamp
      if (!isNaN(ts)){
        let dif = ts - this.hoje
        if(dif < 0){
          comentario.timestamp = this.getTime(ts)
        } else {
          comentario.timestamp = moment(comentario.timestamp).format('HH:mm')
        }

      }

      // console.log(ts)
    })
  },
  methods: {
    ...mapActions(['getVideoAction']),

    trocaVideo(novo, i){
      // console.log(novo.videoId, i)
      let velho = this.video
      this.patrocinio = []
      // this.sponsors = []
      // this.videos = this.videos.splice(i, 1, vid)
      // this.videos = this.videos.join()
      // console.log(velho)
      // console.log(novo)
      // console.log(this.videos)
      // console.log(this.videos.splice(i, 1, velho))
      this.video = novo
      if(novo.patrocinio){
        let novoPat = 'https://centrofluminense.com.br/webmeeting-img/img/' + novo.patrocinio

        this.patrocinio.push(novoPat)
      }

      this.comentarios = []
      this.getComments(novo.videoId)
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getTime(time){
      // let fTime = moment(time).calendar()
      let fTime = moment(time).fromNow()
      // console.log(fTime)
      return fTime
    },
    sendMessage(){
      // let timestamp = Date.now()
      if(this.comentario){

        // console.log(this.video.videoId)
        let vid = db.collection('videos').doc(this.videoId)
        vid.collection('comments')
        .add({
          timestamp: Date.now(),
          msg: this.comentario,
          from: this.user.email,
        }).then(() => {
          this.comentario = null
        })
      } else{
        return false
      }
      // db.collection('comments_2020-05-26')
    },
    getVideo(id){
      db.collection('videos')
        .doc(id)
        .get()
        .then(doc => {
          let video = doc.data()

          if(video.display){
            this.getComments(id)
            this.video = video
            if(video.patrocinio){
              video.patrocinio.forEach(patrocinador => {
                let pat = 'https://centrofluminense.com.br/webmeeting-img/img/' + patrocinador
                this.patrocinio.push(pat)
              })
            }else if(video.sponsors){
              video.sponsors.forEach(sponsor => {
                let spn = 'https://centrofluminense.com.br/webmeeting-img/img/' + sponsor
                this.sponsors.push(spn)
              })
            }

          } else{
            if (video.url){
              this.videos.push(video)
            }
          }
        })
        .catch((e) => console.log('erro ao buscar o video: ', e.message))
      // console.log(this.videos)
    },
    getComments(id){

      // console.log(id)
      let vid = db.collection('videos').doc(id)

      vid.collection('comments').orderBy("timestamp", "asc")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type === "added"){
            let comm = change.doc.data()
            comm.id = change.doc.id
            this.comentarios.unshift(comm)
            // this.updateScroll()
          }
          if(change.type === "removed"){
            // console.log('change.doc.id: ' + change.doc.id)
            // console.log('array comentarios: ' + this.comentarios)
            let comm = change.doc.data()
            comm.id = change.doc.id
            for (let i = 0; i < this.comentarios.length; i++) {
              // console.log('entrou aqui no for')
              // console.log('comm: ', comm.id)
              // console.log('this.comentarios[i].id: ', this.comentarios[i].id)
              if (this.comentarios[i].id === comm.id) {
                // console.log('achei')
                this.comentarios.splice(i, 1)
              } else {
                // console.log('nao achei')
              }
            }
          }
        })
      })
    },
    updateScroll(){
      let commentList = document.querySelector('#comment-list');
      commentList.scrollTop = commentList.scrollHeight + 100;
    }
  },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

.topo{
  // background-color: $primary;
  padding-top: 0px;

  .bg{
    background-color: $primary;
    min-height: 600px;
  }
  .first-row{
    margin-top: -600px;
  }
  .video{

    iframe{
      width: 100%;
      height: 100%;
    }
  }
  .video-title{
    font-size: 2rem
  }
  .sponsors{

    .v-image{
      // max-width: 40px;
    }
  }
  .show-more-btn{
    text-transform: none !important;
    letter-spacing: 1px;
  }
  .ad{
    // position: absolute;
    // bottom: 0;
  }
  .gradient-overlay{
    height: 100px;
    position: sticky;
    bottom: -8px;
    left: 0;
    right: 0;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    background: linear-gradient(0deg, rgba(250,250,250,1) 0%, rgba(255,255,255,.0) 100%);
    &.theme--dark{
      background: linear-gradient(0deg, rgba(30,30,30,1) 0%, rgba(30,30,30,.0) 100%);
    }
  }
  .comment-col {
    overflow: hidden;
    position: relative;
    @include xs {
      min-height: 40vh;
    }
  }
  .comment-container{
    // min-height: 85%;
    overflow-y: scroll;
    -ms-overflow-style: none;
    min-height: 450px;
    max-height: 550px;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .get-online{
    min-height: 13%;
  }
  #comment-list{

    div{
      background-color: #E0F2F1;
    }
    p{
      font-size: .8em;
      margin-bottom: 0px;

      span{
        font-weight: 300;
        font-size: .7em;
        float: right
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .com{
    font-size: .8em;
    background-color: transparent;
    height: 60%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .comment-input{
    // background-image: -webkit-linear-gradient(rgba(255,255,255,0.001) 0%, white 20%);

    .com-input{

      .v-icon{
        background-color: #BDBDBD;
      }

      &.v-input--is-focused{

        .v-label--active{
          color: black;
        }
        .v-icon{
          color: white !important;
          background-color: #00BFA5;
        }
      }
    }
  }
}
.videos{

  .v-card__title{
    font-size: 1em
  }
}

</style>
